module.exports = __webpack_public_path__ + "static/media/scale1.1d18e118.png";